var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.5C21 16.299 16.299 21 10.5 21C4.70099 21 0 16.299 0 10.5C0 4.70099 4.70099 0 10.5 0C16.299 0 21 4.70099 21 10.5ZM9.28547 16.0597L17.0758 8.26934C17.3403 8.00481 17.3403 7.57588 17.0758 7.31134L16.1178 6.35335C15.8533 6.08877 15.4243 6.08877 15.1598 6.35335L8.80645 12.7066L5.84024 9.7404C5.57571 9.47587 5.14678 9.47587 4.8822 9.7404L3.92421 10.6984C3.65967 10.9629 3.65967 11.3919 3.92421 11.6564L8.32743 16.0596C8.59201 16.3242 9.0209 16.3242 9.28547 16.0597Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.84ce30a67b3f807809eecec8b1c69853.svg";
export { ForwardRef as ReactComponent };